export var DossierStep;
(function (DossierStep) {
    DossierStep["ERROR"] = "error";
    DossierStep["CONSENTS"] = "consents";
    DossierStep["SIGNATORIES"] = "signatories";
    DossierStep["OCCUPANTS"] = "occupants";
    DossierStep["EXPLICATIONS"] = "explications";
    DossierStep["SUMMARY"] = "summary";
    DossierStep["DOCUMENTS"] = "documents";
    DossierStep["VALIDATED"] = "validated";
})(DossierStep || (DossierStep = {}));
